import { SvgIcon } from '@material-ui/core'

export const Principle = () => {
  return (
    <SvgIcon
      style={{ fontSize: '50px' }}
      height="1em"
      width="1em"
      viewBox="0 0 55 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Admin_ChildEntity_Integrations"
          transform="translate(-59.000000, -489.000000)"
        >
          <g
            id="Principle"
            transform="translate(57.000000, 486.000000)"
          >
            <image
              id="icons8-arrow_pointing_left-copy-2"
              transform="translate(14.000000, 15.500000) rotate(-180.000000) translate(-14.000000, -15.500000) "
              x="0"
              y="1.5"
              width="28"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAAz1JREFUeAHt3MuS0kAUgGEuCzbqwrVPYs1ex50vA7ISV8jGx1GrnOU472D5DlZ5qbJYAJ4eyAwxSZ/uTqebIT8bIJdO8v1FgDA1gwE3BBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCChwHK5XCTc3ElsanQSeyE7ccB/eyr7k2o/TiJAX/FN5OwB+oyfPUDf8bMGAN/wZzoFgb/HzxIA/Hv85AHAL+MnDQB+FT9ZAPDr8ZMEAL8Zv/MA4NvxOw0Avo7fWQDw3fA7CQC+O370AOD74UcNAL4/frQA4IfhRwngiX8dvqvnueawzWH54q/X68vJZPK7zTYfwLrm+K5Go9F8Npt90/Y3+BexEPzFYvFH26EzmP9YjuH1ZrO5Wa1Wz7TjCQoAvsY6GAyHw6fb7faDtqR3APA10tL8F6VnNU+8Anjif5Xz4KuenHZqaG8nPWmaUUx3DhCAfylvQuf+hls4Bt87BQA/2FddUQ0AvmrYagHr9wDwdVsx2tmWms/nVuPGVwD4NtZ482oDgB8PWBupEgB8jSzu/EoAGf6vxyas5zePcXq7aCWAvGmsROONo8hz+br9Wa55mOsf3AIEKgHMGEQIkAxcpTYAEQI1A1ZTz+HypjyTcd87jn0j139e2i5ByHjWz82O23kwiwV/DyiOkNNRIdHNfeMp6HhzRDjWiPvYKYDZJBHiwhejOQc4ivCuWFm5Nx9RP8rvAY+U5c559k/t4LwCmMHklbCQO9cIF/Ij/KceR7gyZrabdwAzGBFspPt5u93ux3g8nmtLqh9DbQN4Xje67smfpfwSsy8Gfzqdfrf5mXmtApgBfCPIKhdmvaabvLpa71PT2Kc4PegUdHwgh9OR67UjK/7xuH153DqAgZIIPhfw+mLrdJxRAhDBybp2oWgBiFDrq06MGoAIqndlgegBiFAxtk7oJAARrOalmZ0FIELJufFJpwGI0Oh+N6PzAES4s659kCQAEWrtbycmC0CE+ghJAxChGiF5ACKUI2QJQIT7CNkCEGEfIWsAImT6v6H3L8D9I35P+F8k0/PDz5uZts5mEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAIFuBP4Bw4wrGg+v75YAAAAASUVORK5CYII="
            ></image>
            <image
              id="icons8-university"
              x="29"
              y="0"
              width="30"
              height="30"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAAtVJREFUeAHtmzFu20AQRRUhgFzYuUoQ5CwG4hwgSK1GUKdO0BXkypUPkNZXcOEqt0iRNKmU7AIq6B9CHDDav0voCWAxEsW/+94MQBaczfhAAAIQgAAEIAABCEAAAhCAAAQuicCbKW52t9vdHA6Hu7T2L8f17+fz+eNqtfo1tf1MSsB2u/14hJ7h3wjsDP8xHfv1ev0svzVbNi9Auj0LiHyygElMRbMCBro9IiGf0/xUNCVgZLdHZTQ5FU0IOFO3R0U0NRXVBBTu9qiM6lNhF2Du9qiIalNhEVCw21+OhN9HSQfOs05FUQGFuv13gvgtHfl+/ykD7eR8TuV1/u4MH8tUnF1AwW7/nqA+LBaL++Vy+aMP8GazeZd+/5R++5qOD33njPyu2FScTUCnC/ueUkfue/ZPt0cv1FlP01PxXwJqdntUROtTMUpAp7ua6PaojM66m5mKsIApdHtUREtTMSig0zWT6vaojM7+qkxFRMCf6GYC5w3eyQSuUeSUUlORbpVPMn5bZDevLzr6Tub1ZcpWScDPlLDPR6Gp6N2AQ8BVSr7NR9pY7yIu+cv5JW++hb0joLIFBCCgMoHK8UwAAioTqBzPBFQWcPIprW9t6V7+5JPx0JPfpf9fmTIBSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETM9eB7wkPv9ZrXO7m4ofemmYDKShGAgMoEKsczAQioTKByPBOAgMoEiIcABCAAAQhAAAIQgAAEIAABCEAAAhCAgInAXy/26XNmo97pAAAAAElFTkSuQmCC"
            ></image>
          </g>
        </g>
      </g>
    </SvgIcon>
  )
}
